<template>
  <div class="self-header">
    <div class="header-left">
      <div class="title" @click="goPage('Flow')">公司转让</div>
    </div>
    <div class="header-right">
      <el-button v-permissions="'transfer:add'" class="btn-add" size="mini" type="primary" @click="goPage('FlowDetail', 'add')">发布 </el-button>
      <el-popover placement="bottom" width="200" trigger="click">
        <p class="text-primary" style="margin-bottom: 2vh">
          {{ userInfo.endBillingPeriod && userInfo.endBillingPeriod.substring(0, 10) }} 到期
        </p>
        <div class="nav">
          <el-button
            size="mini"
            type="warning"
            @click=";(dialogVisable = true), (form = { old: '', new: '', new1: '' })"
            >修改密码
          </el-button>
          <el-button size="mini" type="danger" class="btn" @click="loginOut">退出登录</el-button>
        </div>
        <div class="info-box" slot="reference">
          <span class="avatar">
            <img :src="userInfo.headimgurl || userImg" />
          </span>
          <span
            >{{ userInfo.companyName }} - {{ userInfo.name }}
            <i class="el-icon-caret-bottom"></i>
          </span>
        </div>
      </el-popover>
    </div>
    <van-popup v-model="pickerShow" position="left" :style="{ width: '50%', height: '100%' }">
      <Navbar></Navbar>
    </van-popup>
  </div>
</template>
<script>
import Navbar from './Navbar'
export default {
  name: 'self-header',
  props: {
    title: {
      type: String,
      default: '标题'
    }
  },
  components: {
    Navbar
  },
  data() {
    return {
      navIsCollapse: this.$store.state.navIsCollapse,
      userInfo: {
        company: '代账公司',
        userImg: require('@/assets/img/user.png')
      },
      userImg: require('@/assets/img/user.png'),
      noticeLogo: require('@/assets/img/icon-notice.png'),
      pickerShow: false,
      dialogVisable: false,
      form: {
        old: '',
        new: '',
        new1: ''
      }
    }
  },
  methods: {
    goPage(name, type) {
      this.$router.push({
        name: name,
        params: {
          id: null,
          webState: type
        }
      })
    },
    toggle() {
      console.log(this.$store.state.navIsCollapse)
      this.$store.dispatch('navIsCollapse', !this.$store.state.navIsCollapse)
      this.navIsCollapse = this.$store.state.navIsCollapse
    },
    loginOut() {
      this.$root.$children[0].vueConfirm(
        { message: '确定退出登录吗？', title: '提示', type: 'warning' },
        () => {
          this.$common.session.clear()
          this.$router.push('/')
        },
        () => {}
      )
    },
    updatePwd() {
      if (!this.form.old) {
        return this.$root.$children[0].vueAlert({ message: '请输入旧密码！', type: 'warning' })
      }
      if (!this.form.new) {
        return this.$root.$children[0].vueAlert({ message: '请输入新密码！', type: 'warning' })
      }
      if (this.form.new !== this.form.new1) {
        return this.$root.$children[0].vueAlert({ message: '请再次确认新密码！', type: 'warning' })
      }
      this.$confirm('确定要修改密码吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const param = {
            id: this.userInfo.cid,
            oldPwd: this.form.old,
            newPwd: this.form.new
          }
          this.$get('/user/updatePwd', param).then(
            result => {
              if (result.status === 200) {
                this.dialogVisable = false
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' }, () => {
                  this.$common.session.clear()
                  this.$router.push('/')
                })
              } else {
                this.$root.$children[0].vueAlert({ message: result.status + ':' + result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消修改' })
        })
    }
  },
  watch: {},
  mounted() {
    if (this.$common.session.get('userInfo')) {
      this.userInfo = this.$common.session.get('userInfo')
    } else {
      return this.$root.$children[0].vueAlert({ message: '未获取到用户信息', type: 'warning' })
    }
  }
}
</script>
<style lang="less">
.el-popover {
  .nav {
    display: flex;
    justify-content: space-between;
  }
}
</style>
<style lang="less" scoped>
.self-header {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #bbbbbb;
  padding: 0 15px;
}
.icon {
  font-size: 3vh;
  color: #333;
  line-height: 5vh;
}
.header-left {
  display: flex;
  align-items: center;
  flex: 1;
  .menu {
    width: 64px;
    .tu {
      padding: 5px 0;
      width: 25px;
      height: 3px;
      margin-left: 0.5vw;
      background: #d8d8d8;
      background-clip: content-box; //背景颜色从内容区域开始绘制
      border-top: 3px solid #d8d8d8;
      border-bottom: 3px solid #d8d8d8;
    }
  }
  .title {
    flex: 1;
    font-size: 20px;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.header-right {
  display: flex;
  padding-right: 20px;
  justify-content: right;
  .btn-add {
    width: 120px;
    margin-right: 20px;
    letter-spacing: 5px;
  }
  .avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    margin-right: 1vw;
    img {
      border-radius: 50%;
      height: 4.2vh;
    }
  }
  .info-box {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    overflow: hidden;
    height: 100%;
    color: #333;
    text-align: right;
    font-weight: bold;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .icon {
    font-size: 3vh;
    color: #333;
    line-height: 5vh;
  }
  .title {
    line-height: 1.5 !important;
    margin-bottom: 0;
  }
  .header-right {
    .avatar {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      cursor: pointer;
      img {
        border-radius: 50%;
        height: 3.1vh;
      }
    }
  }
}
</style>
